import { Divider, Grid } from "@mui/material";
import { memo } from "react";
import { useBuildingDetailUnidContext } from "../../../../context/BuildingDetailUnidContext";
import MxTypography from "@rf-l1/MxTypography";
import styled from "@emotion/styled";

const BuildingUnitFormIndexSection = memo(() => {
  const { indexUnit } = useBuildingDetailUnidContext();
  return (
    <Grid container item flex={1}>
      <Divider flexItem orientation="vertical" />
      <ContentUnit container flex={1}>
        <MxTypography variant="overline" color="primary.main" fontWeight={600}>
          {indexUnit + 1}
        </MxTypography>
      </ContentUnit>
    </Grid>
  );
});

export default BuildingUnitFormIndexSection;

const ContentUnit = styled(Grid)(({ theme }) => ({
  height: 40,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& .MuiOutlinedInput-root": {
    borderRadius: 0,
    "*": {
      border: `0px`
    }
  }
}));
